/* lib/useTabSwipe.js — EL SWIPE ENTRE LAS PESTAÑAS DE LA PÍLDORA (Tanda COS-I).
 *
 * Hermano de `useEdgeSwipeBack.js`, del que importa las constantes compartidas
 * (slop, flick, red de seguridad). Aquel archivo NO se tocó: sus guardas de
 * fuente siguen mordiendo, y sus dos gestos —el de salida desde el borde y el
 * de cambiar de tarjeta— siguen siendo suyos.
 *
 * ── DEL SABOR A AL DEDO PEGADO: LA HISTORIA EN TRES TANDAS ──────────────────
 * COS-I lo estrenó DISCRETO —el "Sabor A"—: deslizar horizontal y, AL SOLTAR
 * pasado el umbral, la vecina entraba con una animación rápida. Durante el
 * recorrido este archivo no escribía UN SOLO estilo, y el porqué estaba escrito
 * aquí mismo: la vecina no existía todavía en el árbol, así que no había qué
 * pegarle al dedo. PAGER-2 la montó (el carril, más abajo). PAGER-3 —esta
 * tanda— le pega el dedo: ya dueño del gesto, el nodo sigue al dedo 1:1 en cada
 * `touchmove` y las DOS pantallas se mueven EN VIVO, como en Instagram.
 *
 * El "Sabor A" y su *"la vecina no viene pegada al dedo"* mueren aquí. Lo que
 * queda de aquel diseño —y no es poco— es TODO lo demás: los umbrales, el
 * candado de dirección, las fuentes excluidas, la háptica y el embudo de
 * navegación por la píldora no cambiaron ni un carácter.
 *
 * ── EL ORDEN, Y QUE NO DA LA VUELTA ─────────────────────────────────────────
 * Inicio ↔ Estudiar ↔ Analíticas ↔ Mejorar plan, el orden de la píldora. En los
 * extremos NO hay vecino: desde Inicio hacia la derecha no pasa nada, y desde
 * Mejorar plan hacia la izquierda tampoco. "More" queda FUERA a propósito: es
 * un cajón, no una pantalla. Swipe a la IZQUIERDA = la pestaña de la DERECHA.
 *
 * ── NAVEGAR ES EL MISMO TAP DE LA PÍLDORA ───────────────────────────────────
 * Al commit se dispara un `click()` sobre el DESTINO DE LA PROPIA PÍLDORA
 * (`[data-nav-to="…"]`, que MobileBottomNav emite sólo en app). En este archivo
 * NO hay `useNavigate`, ni `navigate(`, ni `Link`, ni `history`: no existe una
 * segunda ruta de navegación, exactamente como en el arrastre por la píldora
 * (`finDelGesto`). Por eso el swipe hereda TODOS los efectos del tap — incluido
 * el candado de sesión, donde el destino no es un ancla sino el botón que
 * levanta el toast. Lo fija una guarda de fuente.
 *
 * Leer `document.querySelector` no es colgar un listener de `document`: la
 * doctrina S-7 prohíbe lo segundo, y aquí no hay ni uno. Los cuatro listeners
 * táctiles cuelgan del CONTENEDOR de la pantalla, por ref de callback.
 *
 * ── LA MECÁNICA DEL DEDO, DECLARADA (PAGER-3) ───────────────────────────────
 * Tres tiempos, y SÓLO `transform` (la lección de `glass-card` y su
 * `transition: all .3s`: aquí no se anima una sola propiedad de layout):
 *
 *   1. ARRASTRE. Pasado `DIRECTION_SLOP_PX` con dominante horizontal —ni un
 *      píxel antes— el nodo sigue al dedo: `translateX(dx)` sin transición, en
 *      cada `touchmove`. Se escribe DIRECTO en el nodo: cero re-render de React
 *      por el gesto. Hacia un EXTREMO (donde no hay vecina) el recorrido visual
 *      se frena con `BORDE_RESISTENCIA`: la liga de iOS, que dice "por aquí no
 *      hay nada" sin bloquear el dedo.
 *   2. ASENTAMIENTO, y son DOS, los dos visibles y con el mismo reloj y curva
 *      (`TAB_SLIDE_CSS`), los dos arrancando DESDE DONDE EL DEDO SOLTÓ:
 *        · COMMIT — sigue hasta la vecina (`translateX(±ancho)`).
 *        · CANCELACIÓN — resorte de vuelta al reposo. Cero navegación, cero
 *          click, cero háptica y cero residuo: al terminar, el nodo queda como
 *          si nadie lo hubiera tocado (ley H-1).
 *   3. ATERRIZAJE (sólo tras un commit). Terminado el deslizamiento se dispara
 *      el tap de la píldora y el router hace lo suyo. Ese `click()` no cambió ni
 *      un carácter.
 *
 * QUÉ NODO SE PINTA, Y POR QUÉ ES LA MITAD DEL ASUNTO. El hook no sabe —ni
 * quiere saber— qué hay dentro de su contenedor; pinta el nodo donde cuelgan sus
 * listeners y mide SU ancho. Hasta PAGER-1 ese nodo era el contenedor de UNA
 * pantalla, así que el commit animaba la salida de la pantalla actual y la
 * vecina entraba después con su propia animación de montaje (`animate-fade-in-up`):
 * el hueco estaba escrito aquí mismo — "para que la vecina entre deslizándose
 * las dos pantallas tendrían que estar montadas a la vez, y eso es otra tanda".
 * ESA TANDA FUE PAGER-2, y la nota queda cerrada.
 *
 * PAGER-2 las montó. El hook lo llama ahora UNA sola vez `components/PagerRaices.js`
 * sobre la capa del gesto del CARRIL, que lleva las cuatro raíces vivas lado a
 * lado. La misma línea de `paint` que antes sacaba una pantalla de cuadro corre
 * el carril entero: las DOS pantallas —la que se va y la que llega— se deslizan
 * juntas, con contenido vivo, y ninguna se monta ni se desmonta en el camino.
 * PAGER-3 sólo cambia CUÁNDO se llama esa línea: antes, una vez al soltar; ahora,
 * en cada `touchmove` mientras el dedo esté abajo. La contra vieja (que el
 * `@keyframes` de montaje le ganara al transform en línea) murió con el
 * remontaje: en la app ya no hay montaje que animar, y por eso el fade-in de
 * entrada de esas raíces deja de verse ahí. En web nada de esto existe.
 *
 * ── LA VECINA SIGUE DORMIDA MIENTRAS ARRASTRAS ──────────────────────────────
 * Pegarle el dedo NO la despierta. La activación sigue siendo LA LLEGADA (el
 * aterrizaje del router, `lib/pager/activacion.js`): durante todo el recorrido la
 * vecina pinta su SEMILLA —contenido vivo, no una silueta— y no manda ni una
 * petición. Arrastrar y arrepentirse no cuesta un solo byte de radio.
 *
 * ── EL ATERRIZAJE ES DEL ROUTER, Y ESTE ARCHIVO LO OBEDECE ──────────────────
 * Cuando el `click()` navega, `tab` cambia (el carril le pasa el `pathname`) y
 * el efecto DE LAYOUT de más abajo suelta el transform en línea en el MISMO
 * commit en que React coloca el carril en su nueva posición de reposo, antes del
 * primer paint: el usuario no ve un solo brinco. Si el click NO navegó —candado
 * de sesión, píldora fuera de pantalla— nadie cambia `tab` y entonces sí entra
 * el respaldo de `SETTLE_GUARD_MS`, que devuelve el carril a su sitio.
 *
 * ── TANDA 12 (#183) — Y CUANDO EL ROUTER TARDA, EL CARRIL YA NO ESPERA ──────
 * "El MISMO commit" de arriba es verdad cuando React commitea la navegación
 * pronto. La bitácora del build 87 midió que muchas veces NO: `BrowserRouter` de
 * react-router 7 envuelve la ubicación en `React.startTransition` (está escrito
 * en `lib/diag/navLoc.js`), así que `pushState` corre DENTRO del click y el
 * commit de React llega 150–300 ms después. En esa ventana el transform del
 * gesto sobrevivía sin que nadie hubiera colocado el riel — y el tripwire
 * acababa curando `translateX` de 49 px, −65 px y 416 px al aterrizar. Ese
 * hueco ES el flashazo.
 *
 * Ahora la ventana no existe: EN EL INSTANTE DEL COMMIT —el mismo frame en que
 * se dispara el `click()`— el carril se coloca solo, por escritura directa al
 * DOM y en dos escrituras inseparables:
 *   (a) el riel va a la posición de reposo del DESTINO (lo escribe el carril,
 *       que es quien conoce la geometría: `aterrizarRiel`), y
 *   (b) el transform del gesto se suelta.
 * Las dos juntas pintan EXACTAMENTE el mismo cuadro que se veía al terminar el
 * deslizamiento, así que no se mueve un píxel; y cuando React llegue con su
 * `left` encontrará el valor que ya está puesto. En reposo NO queda transform
 * (doctrina de los overlays de pantalla completa, `components/PagerRaices.js`):
 * la posición la sigue llevando el riel.
 *
 * SÓLO SI EL ROUTER DE VERDAD SE MOVIÓ, y ESA PREGUNTA NO ES DE ESTE ARCHIVO.
 * El discriminador es el mismo que `navLoc` documenta —¿la ruta del documento ya
 * es la del destino?— y lo contesta el CARRIL (`yaNavegoA`), que es quien tiene
 * la ruta; aquí sólo se le pregunta. Este hook sigue sin conocer al router: su
 * única salida a navegar es, como siempre, el `click()` sobre el nodo de la
 * píldora, y hay una guarda de fuente que lo fija. Si la respuesta es "no"
 * —candado de sesión, píldora bloqueada— no se toca un solo estilo y el respaldo
 * de `SETTLE_GUARD_MS` hace su trabajo de siempre, carácter por carácter.
 *
 * ── COLA DE UNO ─────────────────────────────────────────────────────────────
 * Aterrizar antes que React abre la puerta a lo otro que la bitácora vio:
 * commits encimados. Mientras un aterrizaje está EN VUELO (ya se aterrizó, React
 * todavía sin confirmar), el siguiente commit NO dispara su `click()`: se ENCOLA,
 * con capacidad UNO —los intermedios colapsan al último— y se libera en el
 * instante en que React confirma. Lo que NO se encola es la parte visual: el
 * carril aterriza igual, en el acto, así que el dedo nunca se queda esperando y
 * el gesto siguiente nace desde la pestaña que el carril MUESTRA (no desde la que
 * React todavía pinta). La válvula de la cola es el mismo `SETTLE_GUARD_MS`: si
 * una confirmación no llegara nunca, la cola se libera sola y nada queda trabado.
 *
 * ── HÁPTICA: SÓLO EN EL COMMIT ──────────────────────────────────────────────
 * El mismo tic de la píldora, del mismo módulo y con el mismo peso
 * (`lib/haptics.js`, nacido en G-F2/PR #193). Suena UNA vez, al cambiar de
 * pestaña, en el instante de SOLTAR. En la cancelación —soltar antes del umbral
 * o devolverse con un flick— y en los extremos, cero.
 *
 * ── TOQUES DURANTE EL ASENTAMIENTO: IGNORADOS ───────────────────────────────
 * Mientras un asentamiento está en vuelo el pager no atiende dedos nuevos: el
 * `touchstart` se retira sin nacer y sin tocar el temporizador. Atrapar el carril
 * en el aire (el "grab" de iOS) es calibración futura, y sólo si el dedo de
 * Carlos la pide. Lo que esto SÍ compra hoy es que el asentamiento siempre
 * termine: antes, un toque durante el deslizamiento mataba el temporizador del
 * commit y el carril podía quedarse a medio camino con la navegación cancelada.
 *
 * ── CONTRATOS DUROS (los mismos que el hermano) ─────────────────────────────
 *   · SOLO APP. Con `IS_APP_BUILD` en falso devuelve el MISMO objeto vacío
 *     congelado: el contenedor no estrena ni `ref`, ni handler, ni un atributo.
 *   · CERO LISTENERS EN `document` / `window` / `body`.
 *   · `touchstart` y `touchmove` NO PASIVOS y acotados al contenedor.
 *     `touchmove` porque el gesto tiene que poder cancelar el scroll cuando ya
 *     se adueñó del dedo; `touchstart` porque sin ese ancla iOS se compromete
 *     con el scroll en el primer frame y el `touchmove` llega con
 *     `cancelable:false` (WebKit #163207).
 *   · CANDADO DE DIRECCIÓN: mientras el movimiento dominante sea VERTICAL el
 *     gesto se retira y le deja el dedo al scroll. Nunca hay `preventDefault`
 *     antes de que el gesto se declare horizontal.
 *   · FUENTES EXCLUIDAS: un toque que NACE sobre un control de arrastre
 *     horizontal legítimo (los sliders del examen) jamás es swipe de pestaña.
 *   · UN SOLO CLICK TRAGADO, y sólo si de verdad hubo arrastre.
 *   · UN SEGUNDO DEDO CANCELA.
 *   · EL VISOR NO DECIDE NADA. `NAV.TABSWIPE` se escribe al soltar, dentro de
 *     un try/catch.
 *
 * LO QUE JSDOM NO PUEDE JURAR (lo firma el dedo de Carlos en el build): que el
 * arrastre se sienta pegado y no elástico, que el 25% esté bien calibrado ahora
 * que el recorrido SE VE, que `BORDE_RESISTENCIA` frene lo justo, que 290 ms se
 * sienta "rápido" y no brusco, que el tic caiga en el instante correcto, y que
 * iOS respete el `preventDefault` y no se robe el gesto. Aquí se fijan la
 * mecánica, los umbrales y el cableado.
 */
import { useCallback, useLayoutEffect, useRef } from 'react';
import { IS_APP_BUILD } from './buildTarget';
import { hapticImpactLight } from './haptics';
import { log as diagLog } from './diag/readyChainLog';
// tutor-1 (D): la vecina no lleva al Tutor con la perilla apagada (el estado de la sesion, sin red ni `api`).
import { tutorActual } from './tutorDeLaSesion';
import {
  marcarCarril, refrescarCarril, setClickProgramatico, esClickProgramatico,
  registrarPuente, soltarPuente,
} from './carrilEstado';
import {
  DIRECTION_SLOP_PX,
  FLICK_VELOCITY_PX_MS,
  FLICK_MIN_PX,
  SETTLE_GUARD_MS,
} from './useEdgeSwipeBack';

/** EL ORDEN DE LA PÍLDORA, y la única fuente del mapa de vecinos. Es el orden
 *  con el que `MobileBottomNav` arma sus destinos en el build de app; "More" no
 *  está porque no es una pestaña. Sin vuelta en los extremos: fuera de este
 *  arreglo no hay vecino. */
// tutor-1 (D, #665): la cuarta pestana es el Tutor; /upgrade deja de ser raiz (sale de la barra para todos).
export const TAB_ROUTES = ['/dashboard', '/study', '/analytics', '/tutor'];

/** Fracción del ancho que hay que recorrer para cambiar de pestaña. Nació más
 *  corta que el 35% del gesto de salida (`COMMIT_RATIO`) porque éste se recorría
 *  A CIEGAS, y pedir a ciegas más de un cuarto de pantalla se siente a gesto que
 *  no responde. PAGER-3 le quitó la ceguera —ahora el recorrido SE VE— pero el
 *  número NO se mueve: el encargo lo trae con candado y bajar el umbral es
 *  exactamente la clase de cambio que se firma con el dedo, no de paso. */
export const TAB_COMMIT_RATIO = 0.25;

/** LA LIGA DE LOS EXTREMOS (PAGER-3). Hacia el lado donde NO hay vecina —desde
 *  Inicio hacia la derecha, desde Mejorar plan hacia la izquierda— el dedo no se
 *  bloquea: se frena. El recorrido visual es `delta × BORDE_RESISTENCIA`, así que
 *  el carril cede un poco y avisa "por aquí no hay nada" sin sentirse trabado,
 *  que es lo que hacen iOS y sus paginadores.
 *
 *  Nunca hay navegación por ese lado: el commit sigue exigiendo vecina, y en los
 *  extremos no la hay por más fuerte que sea el gesto (eso no cambió).
 *
 *  0.3 es el punto de partida, y es CALIBRABLE por el dedo de Carlos en el smoke:
 *  más bajo = más rígido (más "pared"), más alto = más elástico. */
export const BORDE_RESISTENCIA = 0.3;

/** EL ASENTAMIENTO (los dos: el commit y la cancelación). Sólo `transform`.
 *
 *  TANDA I (B4) — CALIBRACIÓN FIRMADA: 180 → 340 ms. Ésta era la duración
 *  DIVERGENTE del censo: el swipe de pestañas corría a 180 mientras el gesto de
 *  salida corría a 220, así que el cambio de pantalla más frecuente de la app
 *  era además el más brusco de todos. El encargo lo cubre explícitamente ("si
 *  algún hook trae una duración divergente propia, aplícale el 340 igual"), así
 *  que las dos superficies quedan en el MISMO número. La curva ya era `ease-out`.
 *
 *  TANDA N (N2) — RECALIBRACIÓN FIRMADA EN APARATO: 340 → 300 ms. Los 340 de la
 *  tanda I quedaron largos en el iPhone. Sigue valiendo lo de arriba palabra por
 *  palabra salvo el número: las superficies quedan en el MISMO reloj, ahora 300,
 *  y la curva sigue siendo `ease-out`.
 *
 *  PAGER-3 — FIRMA DEL DEDO PEGADO (2026-08-10): 300 → 290 ms, y SÓLO aquí. Es
 *  la primera vez que este reloj se SEPARA del de las tarjetas (`SPRING_MS`, que
 *  se queda en 300 con su candado vigente), y la divergencia es deliberada, no
 *  un descuido: desde esta tanda el número ya no significa "cuánto tarda un
 *  cambio de pantalla a ciegas" sino "cuánto tarda el carril en ASENTAR desde
 *  donde lo dejó el dedo" —el commit y la cancelación—, y a ese asentamiento el
 *  usuario llega con la mayor parte del recorrido ya hecha a mano. Los 10 ms los
 *  firmó Carlos con el arco. La curva sigue siendo `ease-out`.
 *
 *  Ojo con el reloj compuesto de este archivo: `SETTLE_GUARD_MS` arranca DESPUÉS
 *  de `TAB_SLIDE_MS` (el respaldo cuenta desde el tap de la píldora, no desde el
 *  dedo), así que el peor caso pasa de 340+820=1160 a 290+820=1110 ms. Sigue
 *  siendo respaldo: en el camino bueno lo cancela el aterrizaje del router, y
 *  sólo se ve cuando el click NO navegó (PAGER-2).
 *
 *  REMATE-266: y hasta esta tanda ese "en el camino bueno lo cancela el
 *  aterrizaje" era falso cuando el aterrizaje caía DENTRO del `click()` — el
 *  respaldo se armaba justo después y quedaba huérfano, así que el peor caso de
 *  1110 ms era también el caso NORMAL. El orden corregido (ver `end`) lo
 *  devuelve a lo que la nota siempre prometió. */
export const TAB_SLIDE_MS = 290;
export const TAB_SLIDE_CSS = `transform ${TAB_SLIDE_MS}ms ease-out`;

/* LAS FUENTES EXCLUIDAS — el censo de la tanda, en un selector.

   · `.exam-slider-tap` es la caja táctil de los DOS sliders del examen
     (StudyCenter.js: preguntas y tiempo límite): arrastrar horizontal ahí es su
     función, no un cambio de pestaña.
   · `[role="slider"]` es el tirador que emite Radix — cubre esos mismos dos y
     cualquier slider futuro, aunque nazca sin la clase de la casa.
   · `input[type="range"]` no existe hoy en ninguna de las cuatro pantallas (el
     censo lo confirmó); va porque es el control de arrastre horizontal nativo y
     el día que alguien lo use no debe hacer falta acordarse de este archivo.

   Se mide con `closest` sobre el target del `touchstart`: lo que importa es
   dónde NACE el dedo, no por dónde pasa. */
export const TAB_SWIPE_EXCLUDED_SOURCES = '.exam-slider-tap, [role="slider"], input[type="range"]';

// El objeto que ve la web: uno solo, congelado y de identidad estable.
const NO_PROPS = Object.freeze({});

/** Reloj del gesto. Los eventos táctiles traen `timeStamp` monotónico; si el
 *  entorno no lo llenara, se cae al reloj de pared. Sólo se usa para velocidad.
 *  (Gemelo del de `useEdgeSwipeBack`: aquel archivo tiene cero líneas de diff en
 *  esta tanda, así que sus helpers privados no se pueden exportar.) */
function stampOf(e) {
  const ts = e && e.timeStamp;
  return typeof ts === 'number' && ts > 0 ? ts : Date.now();
}

/** El ancho contra el que se mide el umbral: el del propio contenedor, y si el
 *  entorno no sabe medir (jsdom no tiene layout), el del viewport. */
function widthOf(node) {
  let w = 0;
  try { w = node.getBoundingClientRect().width || 0; } catch (e) { w = 0; }
  if (w > 0) return w;
  try { return window.innerWidth || 0; } catch (e) { return 0; }
}

/** El vecino en la dirección pedida, o null en los extremos. `paso` vale +1
 *  (hacia la derecha del orden) o -1. */
export function tabVecino(desde, paso) {
  // tutor-1 (D): con el tutor de la sesion apagado, /tutor no es vecina de nadie (el deslizar desde Analiticas no
  // llega a una pantalla vacia). Mientras la llamada no llega manda el ultimo `on` que el estado conoce.
  const rutas = tutorActual().on ? TAB_ROUTES : TAB_ROUTES.filter((r) => r !== '/tutor');
  const i = rutas.indexOf(desde);
  if (i < 0) return null;
  const j = i + paso;
  if (j < 0 || j >= rutas.length) return null;   // SIN dar la vuelta
  return rutas[j];
}

/** El destino, tal cual la píldora lo pinta. Si la barra no está en pantalla o
 *  la ruta no es una pestaña, no hay a dónde ir y el gesto no hace nada. */
function pillNodeFor(ruta) {
  try {
    return document.querySelector(`[data-testid="mobile-bottom-nav"] [data-nav-to="${ruta}"]`);
  } catch (e) {
    return null;
  }
}

/**
 * EL TRAMO FINAL DE TODA NAVEGACIÓN DEL CARRIL (TANDA 17 / #202).
 *
 * Navegar sigue siendo lo de siempre —un `click()` sobre el destino de la propia
 * píldora, y no hay una segunda ruta en este archivo—; lo único que se añade es
 * ANUNCIARLO. La bandera dice "este click lo disparó código, no un dedo", que es
 * lo que le permite a la píldora dejarlo pasar entero en vez de volver a
 * encolarlo.
 *
 * Se exporta porque el tap encolado tiene que salir por EXACTAMENTE este tramo:
 * si la píldora se escribiera el suyo, un cambio aquí dejaría dos desenlaces que
 * divergen en silencio.
 *
 * El `finally` no es adorno: si el `<Link>` de destino tirara una excepción, una
 * bandera pegada en `true` haría que la píldora dejara de encolar taps —y de
 * frenarlos— hasta la próxima recarga. El dispatch de `click` es SÍNCRONO, así
 * que entre las dos escrituras no hay ni un `await` donde se pueda colar nada.
 */
export function clickProgramatico(nodo) {
  /* SE RESTAURA LO QUE HABÍA, no se apaga a ciegas: estos clicks PUEDEN
     anidarse. El aterrizaje de React corre dentro del `click()` y desde ahí se
     libera la cola, que dispara otro click; si el de adentro apagara la bandera
     al salir, el resto del de afuera correría diciendo que lo mandó un dedo.
     Fuera de un anidamiento `previo` es falso y esto es apagarla, igual que
     antes. (Lo cazó la revisión adversarial de la tanda.) */
  const previo = esClickProgramatico();
  try {
    setClickProgramatico(true);
    nodo.click();
  } finally {
    setClickProgramatico(previo);
  }
}

function logTabSwipe(desde, hacia, commit) {
  try {
    diagLog('NAV.TABSWIPE', { desde, hacia: hacia || null, commit: !!commit });
  } catch (e) { /* el visor jamás decide un gesto */ }
}

/** ¿Puede nacer un gesto? `enabled` admite un booleano (una pantalla que ya sabe
 *  al rendear si tiene una capa encima) o una FUNCIÓN, que se pregunta en el
 *  instante del `touchstart`. La segunda forma la estrena PAGER-2: el carril lee
 *  el reporte de la raíz de enfrente desde un ref, sin re-rendear a nadie por un
 *  booleano que sólo importa cuando un dedo toca la pantalla. Con un booleano el
 *  camino es carácter por carácter el de siempre. */
function estaHabilitado(o, ruta) {
  return typeof o.enabled === 'function' ? !!o.enabled(ruta) : !!o.enabled;
}

/**
 * useTabSwipe — el swipe entre pestañas.
 *
 * Lo llama UNA vez el carril (`components/PagerRaices.js`) sobre la capa del
 * gesto, no cada raíz por su cuenta: cuatro juegos de listeners táctiles se
 * quedaron en uno (PAGER-2).
 *
 * @param {object}   opts
 * @param {string}   opts.tab       la ruta de la pestaña de ENFRENTE ('/dashboard', …).
 * @param {boolean|function} [opts.enabled]  falso mientras haya una capa encima:
 *                                  no nacen gestos nuevos (uno en vuelo termina
 *                                  en paz). Función = se pregunta al `touchstart`.
 * @param {function} [opts.aterrizarRiel]  (TANDA 12) el carril coloca su riel en
 *                                  la posición de reposo de la ruta que se le
 *                                  pide, por escritura directa, y contesta si
 *                                  pudo. SIN ella no hay aterrizaje atómico y el
 *                                  camino es carácter por carácter el de antes:
 *                                  el hook no conoce —ni quiere conocer— la
 *                                  geometría de lo que hay dentro de su nodo.
 * @param {function} [opts.yaNavegoA]  (TANDA 12) el carril contesta si el router
 *                                  YA se movió a esa ruta. Es la mitad que le
 *                                  falta al aterrizaje atómico para no dispararse
 *                                  cuando el click no navegó. Sin ella, tampoco
 *                                  hay aterrizaje atómico.
 * @param {function} [opts.publicarRutaVista]  (TANDA 19 / #210) AVISO, no
 *                                  conducta: el hook le dice al carril cuál es
 *                                  la ruta que el usuario tiene DELANTE, para
 *                                  que las raíces que pintan algo anclado al
 *                                  viewport no tengan que esperar al router. Se
 *                                  llama con la ruta destino en el instante del
 *                                  commit del gesto —cuando el carril empieza a
 *                                  asentar hacia ella, que es cuando el usuario
 *                                  la ve llegar— y con `null` en cuanto la
 *                                  verdad vuelve a ser la del router (React
 *                                  confirmó, el gesto se canceló, el click no
 *                                  navegó o el nodo se fue). NADA de este hook
 *                                  depende de ella: sin la función, y aunque
 *                                  lance, el gesto corre carácter por carácter
 *                                  como corría antes.
 * @returns {{ref?: function, onClickCapture?: function}} props para el
 *          CONTENEDOR del gesto. En web, `{}`.
 */
export function useTabSwipe({
  tab, enabled = true, aterrizarRiel = null, yaNavegoA = null, publicarRutaVista = null,
}) {
  const optsRef = useRef(null);
  optsRef.current = { tab, enabled, aterrizarRiel, yaNavegoA, publicarRutaVista };

  const stRef = useRef(null);        // gesto en vuelo, o null
  const timerRef = useRef(null);     // salida en curso, o respaldo de limpieza
  const swallowRef = useRef(false);  // hay un click de compatibilidad que tragar
  const detachRef = useRef(null);
  const nodeRef = useRef(null);      // el nodo que se pinta, mientras esté vivo
  const enVueloRef = useRef(null);   // ruta ya ATERRIZADA que React no confirma aún
  const colaRef = useRef(null);      // el ÚNICO commit encolado, o null
  const valvulaRef = useRef(null);   // respaldo que libera la cola si nadie confirma
  /* PARA QUÉ ES EL TEMPORIZADOR QUE HAY PUESTO. Hasta la TANDA 12 no hacía falta
     preguntarlo: mientras `timerRef` estaba puesto no podía nacer un gesto nuevo,
     así que lo único que podía haber cuando el router aterrizaba era el RESPALDO.
     Ahora sí puede haber un gesto nuevo con su propio deslizamiento en vuelo, y
     el aterrizaje de la navegación ANTERIOR no tiene derecho a matárselo.
     Valores: 'deslizamiento' (el commit, que al vencer dispara el click),
     'resorte' (la cancelación) y 'respaldo' (la red de `SETTLE_GUARD_MS`). */
  const faseRef = useRef(null);

  const handlersRef = useRef(null);
  if (!handlersRef.current) {
    const clearTimer = () => {
      faseRef.current = null;
      if (timerRef.current) { clearTimeout(timerRef.current); timerRef.current = null; }
    };
    const clearValvula = () => {
      if (valvulaRef.current) { clearTimeout(valvulaRef.current); valvulaRef.current = null; }
    };
    const paint = (node, x, animado) => {
      node.style.transition = animado ? TAB_SLIDE_CSS : 'none';
      // Cadena vacía = vuelve a la identidad, sin dejar transform residual.
      node.style.transform = x === 0 ? '' : `translateX(${x}px)`;
    };
    /* EL AVISO DE LA RUTA VISIBLE (TANDA 19 / #210). Leer y avisar, y nada más:
       ni decide, ni guarda, ni se le pregunta. Va con red porque un lector roto
       no tiene derecho a romper un gesto — el carril seguiría asentando igual y
       lo único que se perdería es que la barra llegue temprano. */
    const publicarVista = (ruta) => {
      const avisar = optsRef.current.publicarRutaVista;
      if (typeof avisar !== 'function') return;
      try { avisar(ruta || null); } catch (e) { /* noop */ }
    };
    /* LA LIMPIEZA DE VERDAD, EN UN SOLO SITIO (TANDA 17 / #205). Esta escritura
       —apagar la transición ANTES de soltar el transform, o el navegador animaría
       el regreso a cero en vez de aplicarlo de golpe— estaba copiada en tres
       lugares. Aquí no cambia ni un carácter: es la MISMA, en el mismo orden.

       Y es el único punto del hook que puede afirmar "el carril quedó en su ley
       de reposo", así que es el que lo declara. Que lo diga UNA función y no tres
       copias es la mitad del valor de haberla unificado: un estado que se
       marcara en dos de los tres caminos sería peor que no marcarlo. */
    const limpiarRiel = (node) => {
      try {
        node.style.transition = 'none';
        node.style.transform = '';
      } catch (e) { /* noop */ }
      marcarCarril('reposo');
    };
    /* LA CANCELACIÓN (PAGER-3) — EL RESORTE VISIBLE QUE ANTES NO EXISTÍA.
       Hasta PAGER-2 "no commitear" no tenía animación porque no había nada
       pintado que devolver ("resorte: no se pintó nada"). Con el dedo pegado sí
       lo hay: el nodo vuelve al reposo DESDE DONDE EL DEDO LO DEJÓ, con el mismo
       reloj y la misma curva del commit. Cero navegación, cero click y cero
       háptica — y al terminar se borra también la transición en línea, para que
       en reposo el nodo no conserve ni transform ni animación (ley H-1).
       El temporizador es además el que declara "hay un asentamiento en vuelo",
       que es lo que hace que los toques de encima se ignoren. */
    const cancelar = (node) => {
      // El carril vuelve a la pestaña del router: no hay ruta visible que
      // publicar, y quien pregunte cae a `activa` como siempre (TANDA 19).
      publicarVista(null);
      paint(node, 0, true);
      faseRef.current = 'resorte';
      // El resorte es un ACOMODO, igual que el deslizamiento del commit: el
      // carril está en vuelo y el curador no tiene nada que hacer todavía.
      marcarCarril('settle');
      timerRef.current = setTimeout(() => {
        timerRef.current = null;
        faseRef.current = null;
        try { node.style.transition = ''; } catch (e) { /* noop */ }
      }, TAB_SLIDE_MS);
    };
    /* EL VUELO SE CIERRA (TANDA 12). Una sola puerta para las dos formas de
       cerrarlo —la confirmación de React y la válvula— para que no puedan
       divergir: se apaga el respaldo, se olvida la ruta en vuelo y se DEVUELVE lo
       que hubiera encolado, que es responsabilidad del llamador disparar. */
    const liberarVuelo = () => {
      clearValvula();
      // TANDA 19: se cierra el vuelo = manda el router otra vez. Es la mitad
      // "reconciliación" del aviso, y vive aquí por lo mismo que el resto de
      // este cierre: para que las dos formas de cerrarlo no puedan divergir.
      publicarVista(null);
      enVueloRef.current = null;
      const pendiente = colaRef.current;
      colaRef.current = null;
      return pendiente;
    };
    /* LA PUERTA DE ENTRADA A LA COLA, PARA QUIEN NO ES EL SWIPE (TANDA 17 /
       #202). La semántica no cambia ni un carácter: capacidad UNO y gana el
       último, igual que cuando el único cliente era el deslizamiento. Lo único
       nuevo es que ahora la cola guarda un CIERRE en vez de un par
       `{hacia, node}` —así el tap de la píldora puede encolar su propio
       desenlace— y que contesta si lo tomó.

       SIN VUELO NO HAY COLA: contesta `false` y el llamador navega como
       siempre. Es lo que hace que el 99% de los taps no note esta tanda, y lo
       que impide que un tap se pierda por haberse frenado a cambio de nada. */
    const encolarNavegacion = (fn) => {
      if (!enVueloRef.current) return false;
      colaRef.current = fn;
      return true;
    };
    /* EL ATERRIZAJE ATÓMICO (TANDA 12 / #183). Las DOS escrituras del contrato,
       en el mismo frame y directas al DOM: el riel a la posición de reposo del
       destino (lo hace el carril, que es quien conoce la geometría) y el
       transform del gesto suelto. El orden importa por una razón sola: apagar la
       transición ANTES de borrar el transform, o el navegador animaría el
       regreso a cero en vez de aplicarlo de golpe.
       Devuelve si aterrizó. Sin `aterrizarRiel` (el hook usado suelto, fuera del
       carril) contesta que no y nadie toca un estilo: ése es el camino viejo. */
    const aterrizarAtomico = (hacia, node) => {
      const o = optsRef.current;
      if (typeof o.aterrizarRiel !== 'function') return false;
      if (!o.aterrizarRiel(hacia)) return false;
      limpiarRiel(node);
      // TANDA 19: el carril YA está posado en el destino y React todavía no lo
      // sabe. Es exactamente la ventana que el aviso cubre; en el camino del
      // deslizamiento ya se publicó lo mismo al soltar el dedo, y republicar el
      // mismo valor no despierta a nadie.
      publicarVista(hacia);
      enVueloRef.current = hacia;
      /* LA VÁLVULA. Si la confirmación de React no llegara nunca, la cola se
         quedaría trabada para siempre; con esto se libera sola al mismo plazo
         que el respaldo de siempre. Tras el arreglo no debería disparar. */
      clearValvula();
      valvulaRef.current = setTimeout(() => {
        valvulaRef.current = null;
        const opciones = optsRef.current;
        const vuelo = enVueloRef.current;
        const pendiente = liberarVuelo();
        /* Y LA VÁLVULA TAMBIÉN REPARA, en el único caso en que el `left` escrito
           a mano no converge solo. Lo normal es que converja: sólo se escribe
           cuando el documento YA está en el destino, así que el router notificó y
           React acabará rendeando ese índice y escribiendo el MISMO valor. Lo que
           no converge es la navegación RELEVADA — un botón de atrás, un rebote de
           guarda— que devuelve el documento a la pestaña que React ya tenía: ahí
           React no re-rendea nada (su índice no cambió) y el riel se quedaría
           donde lo dejamos. Se distingue por lo mismo que autorizó el aterrizaje:
           si el documento ya no está donde aterrizamos, aquello se relevó, y el
           riel vuelve a la pestaña que React SÍ tiene. Si React sólo va lento, el
           documento sigue en el destino y aquí no se toca nada. */
        if (vuelo && typeof opciones.yaNavegoA === 'function' && !opciones.yaNavegoA(vuelo)
            && typeof opciones.aterrizarRiel === 'function') {
          opciones.aterrizarRiel(opciones.tab);
        }
        if (pendiente) pendiente();
      }, SETTLE_GUARD_MS);
      return true;
    };
    /* EL COMMIT DEL ROUTER — el tap de la píldora, y lo que pasa justo después.
       Vive aparte porque tiene DOS llamadores: el final del deslizamiento y la
       liberación de la cola. */
    const dispararCommit = (hacia, node) => {
      const nodo = pillNodeFor(hacia);
      if (!nodo) { cancelar(node); return; }
      /* RESPALDO DE LIMPIEZA (PAGER-2). Se arma ANTES del click (REMATE-266/P3):
         el aterrizaje lo cancela caiga cuando caiga. */
      faseRef.current = 'respaldo';
      timerRef.current = setTimeout(() => {
        timerRef.current = null;
        faseRef.current = null;
        // TANDA 19: si este respaldo llega a disparar es que el click NO navegó,
        // y el carril está volviendo a la pestaña del router. El aviso vuelve
        // con él, en la misma línea en que se devuelve la pintura.
        publicarVista(null);
        paint(node, 0, true);
      }, SETTLE_GUARD_MS);
      clickProgramatico(nodo);
      const o = optsRef.current;
      /* React YA está en esta pestaña: o commiteó DENTRO del click (y su efecto
         de layout ya colocó el riel y soltó el transform), o la cola se liberó
         hacia una ruta que entretanto se confirmó sola. En los dos casos no queda
         nada desplazado, así que el respaldo se apaga en vez de quedarse armado
         los 820 ms — que es exactamente la ventana muerta que REMATE-266 cerró. */
      if (o.tab === hacia) { clearTimer(); return; }
      // El click NO navegó (candado de sesión, píldora bloqueada): no se toca un
      // solo estilo y el respaldo de arriba es su red, exactamente como antes.
      // Quien lo sabe es el carril; este archivo no le pregunta al router.
      if (typeof o.yaNavegoA !== 'function' || !o.yaNavegoA(hacia)) return;
      if (!aterrizarAtomico(hacia, node)) return;
      clearTimer();   // ya aterrizamos: el respaldo se queda sin trabajo
    };
    handlersRef.current = {
      start(e) {
        const o = optsRef.current;
        // Un dedo nuevo sobre un gesto en vuelo (el segundo de un pinch) lo
        // CANCELA — y desde PAGER-3 eso incluye devolver el carril a su sitio,
        // porque ya hay algo pintado. Un toque nuevo empieza limpio: nada
        // pendiente de tragar.
        const prev = stRef.current;
        stRef.current = null;
        swallowRef.current = false;
        if (prev && prev.active) { logTabSwipe(prev.tab, null, false); cancelar(prev.node); }
        // ASENTAMIENTO EN VUELO: el pager IGNORA el toque y lo deja terminar (el
        // letrero de arriba dice por qué). Va después del bloque anterior a
        // propósito: lo que se ignora son los dedos que caen sobre un
        // asentamiento AJENO, no el resorte que este mismo toque acaba de armar.
        if (timerRef.current) return;
        /* LA PESTAÑA DESDE LA QUE NACE EL GESTO (TANDA 12). Casi siempre es la
           que React pinta. Pero con un aterrizaje EN VUELO el carril YA está
           mostrando el destino y React todavía no: leer `tab` ahí daría vecinas
           de la pantalla anterior —el dedo se frenaría con la liga en un extremo
           que no existe, o commitearía a donde ya está—. Manda lo que se VE, y
           por eso también se le pasa a `enabled`: la capa que puede haber encima
           es la de la pantalla que el usuario TIENE delante.
           Fuera de esa ventana `enVueloRef` es null y esto es `o.tab`, sin más. */
        const rutaVista = enVueloRef.current || o.tab;
        if (!estaHabilitado(o, rutaVista)) return;
        const touches = e.touches;
        if (!touches || touches.length !== 1) return;   // pinch: no es lo nuestro
        // LAS FUENTES EXCLUIDAS. Nace sobre un slider → el dedo es suyo, y aquí
        // se acaba: ni estado, ni preventDefault, ni línea en el visor.
        const target = e.target;
        try {
          if (target && target.closest && target.closest(TAB_SWIPE_EXCLUDED_SOURCES)) return;
        } catch (err) { /* selector imposible en este entorno: no excluye nada */ }
        const t = touches[0];
        clearTimer();   // cinturón: con la guarda de arriba no puede haber ninguno vivo
        stRef.current = {
          node: e.currentTarget,
          tab: rutaVista,
          /* LAS DOS VECINAS, resueltas UNA vez al nacer el gesto. El arrastre las
             necesita en cada `touchmove` —hacia una vecina el dedo va 1:1, hacia
             un extremo va con liga— y al soltar deciden el commit. Es el MISMO
             mapa de siempre (`tabVecino`), leído una vez en vez de dos: así lo
             que se pinta y lo que se commitea no pueden discrepar. */
          vecinaDer: tabVecino(rutaVista, 1),    // se llega arrastrando a la IZQUIERDA
          vecinaIzq: tabVecino(rutaVista, -1),   // se llega arrastrando a la DERECHA
          x0: t.clientX, y0: t.clientY,
          lastX: t.clientX, lastT: stampOf(e),
          vx: 0, dx: 0, active: false,
          width: widthOf(e.currentTarget),
        };
      },
      move(e) {
        const st = stRef.current;
        if (!st) return;
        const touches = e.touches;
        if (!touches || touches.length !== 1) {
          stRef.current = null;
          if (st.active) cancelar(st.node);   // había recorrido pintado: se devuelve
          return;
        }
        const t = touches[0];
        const dx = t.clientX - st.x0;
        const dy = t.clientY - st.y0;
        if (!st.active) {
          // CANDADO DE DIRECCIÓN. Vertical dominante → el dedo es del scroll y
          // este gesto se retira sin tocar nada.
          if (Math.abs(dy) > DIRECTION_SLOP_PX && Math.abs(dy) >= Math.abs(dx)) {
            stRef.current = null;
            return;
          }
          if (Math.abs(dx) <= DIRECTION_SLOP_PX || Math.abs(dx) <= Math.abs(dy)) return;
          st.active = true;
          /* AQUÍ, Y NO ANTES, EL GESTO SE VUELVE DUEÑO DEL RIEL. Es el mismo
             punto exacto en el que empieza a pintar, así que el estado y lo que
             se ve en pantalla no pueden discrepar: por debajo del slop no hay
             pintura y tampoco hay marca (eso sigue siendo un tap). */
          marcarCarril('gesto');
        }
        // Ya es nuestro: se cancela el scroll horizontal del navegador.
        if (e.cancelable) e.preventDefault();
        const now = stampOf(e);
        const dt = now - st.lastT;
        if (dt > 0) st.vx = (t.clientX - st.lastX) / dt;
        st.lastX = t.clientX;
        st.lastT = now;
        st.dx = dx;
        /* EL DEDO PEGADO (PAGER-3). Aquí, y sólo aquí, se pinta durante el
           recorrido — nunca antes de declararse dueño: por debajo del slop o con
           dominante vertical el gesto ya se retiró más arriba y estas dos líneas
           no se alcanzan, así que el nodo queda sin tocar y sin residuo. Hacia
           donde HAY vecina el carril va 1:1 con el dedo; hacia un extremo, con la
           liga. Sin transición: el nodo va pegado, no persiguiéndolo. */
        const hayVecina = dx < 0 ? st.vecinaDer : st.vecinaIzq;
        // El dedo sigue ahí: la marca se refresca para que un arrastre largo no
        // envejezca hasta cruzar el tope de frescura de quien la lea.
        refrescarCarril();
        paint(st.node, hayVecina ? dx : dx * BORDE_RESISTENCIA, false);
      },
      end() {
        const st = stRef.current;
        stRef.current = null;
        if (!st || !st.active) return;
        // Hubo arrastre: el click de compatibilidad que el navegador pueda
        // mandar al soltar ya no representa lo que el usuario quiso.
        swallowRef.current = true;
        // Izquierda (dx<0) = la pestaña de la DERECHA; derecha = la de la izquierda.
        const hacia = st.dx < 0 ? st.vecinaDer : st.vecinaIzq;
        const recorrido = Math.abs(st.dx);
        const umbral = st.width * TAB_COMMIT_RATIO;
        const flick = Math.abs(st.vx) >= FLICK_VELOCITY_PX_MS && recorrido >= FLICK_MIN_PX;
        /* LA DIRECCIÓN DEL FLICK MANDA (PAGER-3). Con el recorrido a la vista
           aparece un gesto que a ciegas no existía: arrastrar hasta pasado el
           umbral y DEVOLVERSE de un tirón — el "me arrepentí" de iOS. Si hay
           flick válido decide su SENTIDO, no el desplazamiento: hacia la vecina
           commitea aunque sea corto (como siempre), y de regreso al reposo
           CANCELA aunque el neto ya hubiera pasado el umbral.
           Sin flick manda el NETO de siempre, y por eso arrastrar de más y volver
           despacio por debajo del umbral se cancela solo: el neto ya lo resuelve. */
        const flickVaALaVecina = flick && (st.vx < 0) === (st.dx < 0);
        const flickDeRegreso = flick && !flickVaALaVecina;
        // En los extremos NO hay vecino: por fuerte que sea el gesto, no es
        // commit. La línea del visor lo dice con `hacia:null`.
        const commit = !!hacia && !flickDeRegreso && (recorrido >= umbral || flickVaALaVecina);
        logTabSwipe(st.tab, hacia, commit);
        if (!commit) { cancelar(st.node); return; }   // el resorte, ahora visible
        hapticImpactLight();                 // el tic va SÓLO aquí
        /* TANDA 19 (#210) — EL AVISO SALE AQUÍ, Y AQUÍ ES EL PUNTO EXACTO. Éste
           es el instante en que la vecina pasa a ser la pantalla del usuario:
           el commit ya está decidido (el arrepentimiento se resolvió arriba, con
           el flick y el neto) y la línea siguiente arranca el asentamiento hacia
           ella. Todo lo que este hook hace después —el reloj, el tap, el
           aterrizaje, la cola— es el mismo de siempre y no consulta esto para
           nada; lo único que cambia es que la raíz que pinta anclado al viewport
           deja de esperar los `TAB_SLIDE_MS` que tarda el router. */
        publicarVista(hacia);
        // 1er tiempo: el carril sigue hasta la vecina DESDE donde soltó el dedo.
        paint(st.node, st.dx < 0 ? -st.width : st.width, true);
        /* 2º tiempo: EL MISMO TAP DE LA PÍLDORA, con su respaldo y su aterrizaje
           atómico — todo eso vive en `dispararCommit`, arriba, incluido el orden
           REMATE-266/P3 de armar el respaldo ANTES del click.

           LA COLA DE UNO (TANDA 12) es lo único que se decide aquí: si ya hay un
           aterrizaje en vuelo, este commit NO manda su click todavía. Aterriza en
           lo visual —el carril no espera a nadie— y su navegación queda encolada;
           si llegara otra, la releva (capacidad uno, gana el último). Se libera
           en el instante en que React confirma. */
        faseRef.current = 'deslizamiento';
        // El otro acomodo. Mismo letrero que el resorte: hay algo en vuelo.
        marcarCarril('settle');
        timerRef.current = setTimeout(() => {
          timerRef.current = null;
          faseRef.current = null;
          if (enVueloRef.current && aterrizarAtomico(hacia, st.node)) {
            colaRef.current = () => dispararCommit(hacia, st.node);
            return;
          }
          dispararCommit(hacia, st.node);
        }, TAB_SLIDE_MS);
      },
      /* EL ATERRIZAJE. Se llama SÓLO cuando el router ya cambió de pestaña, y
         por eso limpia SIN animar: la posición de reposo que React acaba de
         escribir en el carril y la que dejó el deslizamiento son la misma, así
         que soltar el transform en línea no mueve un píxel. Animarlo aquí sería
         devolver el carril a la pestaña vieja a la vista del usuario.

         Y ES QUIEN CANCELA EL RESPALDO (REMATE-266 / P3). `clearTimer()` estaba
         aquí desde PAGER-2, pero el respaldo se armaba DESPUÉS de este punto en
         el camino síncrono y por eso no lo alcanzaba; con el orden corregido
         arriba, esta línea es la que cierra la ventana muerta del pager. */
      aterrizar(node) {
        /* TANDA 12 — Y ES TAMBIÉN LA CONFIRMACIÓN QUE LA COLA ESPERA. React
           acaba de decir cuál es la pestaña: el vuelo se cierra y, si había una
           navegación encolada, sale AQUÍ. Sale después de soltar el transform a
           propósito: si el click de la cola no navegara, el carril se queda en la
           posición que React acaba de escribir, que es reposo legítimo. */
        const pendiente = liberarVuelo();
        /* ── TANDA 12 — Y NO LE ARRANCA EL CARRIL AL DEDO DE AHORA ─────────────
           Hasta esta tanda esto podía limpiar a ciegas: mientras había un
           temporizador puesto no nacían gestos nuevos, así que lo único que podía
           encontrar aquí era el RESPALDO de la propia navegación que acababa de
           aterrizar. Desde que el aterrizaje atómico apaga ese respaldo, el dedo
           puede volver a entrar en el acto — y entonces lo que hay puesto puede
           ser el deslizamiento de un gesto POSTERIOR, o el dedo mismo todavía
           abajo. Limpiarlo sería matarle el commit a ese gesto: tic háptico,
           medio deslizamiento y ninguna navegación. Lo cazó la revisión
           adversarial de esta misma tanda, y era real y alcanzable dentro de la
           banda medida (React confirma en 150–300 ms; el deslizamiento dura 290).

           Así que la confirmación de una navegación VIEJA no toca nada que sea de
           un gesto NUEVO: ni su temporizador ni su pintura. Ese gesto terminará
           por su cuenta —su propio aterrizaje o su propio respaldo—, que es
           justo lo que tiene que pasar. */
        const st = stRef.current;
        const ajeno = !!(st && st.active)
          || faseRef.current === 'deslizamiento'
          || faseRef.current === 'resorte';
        if (!ajeno) {
          clearTimer();
          if (node) limpiarRiel(node);
        }
        if (pendiente) pendiente();
      },
      cancel() {
        const st = stRef.current;
        stRef.current = null;
        if (!st || !st.active) return;
        logTabSwipe(st.tab, null, false);
        cancelar(st.node);   // el sistema se llevó el dedo: el carril vuelve solo
      },
      /* EL PUENTE (TANDA 17 / #202). Lo mínimo que la píldora necesita para
         meter su tap en ESTA cola: si hay un aterrizaje en vuelo, y por dónde
         encolar. `enVueloRef` es la respuesta completa —la válvula se arma y se
         apaga con él, en `aterrizarAtomico` y en `liberarVuelo`—, así que no hay
         una segunda fuente de verdad que se pueda desincronizar. */
      hayVuelo: () => !!enVueloRef.current,
      encolar: encolarNavegacion,
      detach(node) {
        clearTimer();
        liberarVuelo();   // el nodo se va: no queda vuelo ni cola que liberar
        soltarPuente();   // y la píldora vuelve sola a ser el `<Link>` de siempre
        stRef.current = null;
        swallowRef.current = false;
        limpiarRiel(node);
        /* EL NODO SE VA, Y SE VA COMO SIEMPRE. `limpiarRiel` deja `none` en la
           transición (es lo que hace falta cuando el nodo SIGUE vivo); aquí no,
           y este renglón conserva el estado final exacto que el desenganche
           dejaba antes de la tanda, carácter por carácter. */
        try { node.style.transition = ''; } catch (e) { /* noop */ }
      },
    };
  }

  /* Ref de callback que engancha los cuatro listeners EN EL NODO y los suelta
     cuando el nodo se va (cambio de pantalla o desmontaje). Los envoltorios
     dereferencian en el momento de la llamada, así que la identidad de la ref es
     estable para siempre: React no re-engancha en cada render. */
  const ref = useCallback((node) => {
    if (detachRef.current) { detachRef.current(); detachRef.current = null; }
    nodeRef.current = node || null;
    if (!node) return;
    const h = handlersRef.current;
    const start = (e) => h.start(e);
    const move = (e) => h.move(e);
    const end = (e) => h.end(e);
    const cancel = (e) => h.cancel(e);
    // No pasivos los dos primeros: ver el contrato de arriba (WebKit #163207).
    node.addEventListener('touchstart', start, { passive: false });
    node.addEventListener('touchmove', move, { passive: false });
    node.addEventListener('touchend', end);
    node.addEventListener('touchcancel', cancel);
    // El carril ya está enganchado: desde aquí la píldora puede preguntar por la
    // cola. Se suelta en `detach`, abajo, así que fuera de la app —donde este
    // callback no corre nunca— no hay puente y el tap es el de siempre.
    registrarPuente({ hayVuelo: h.hayVuelo, encolar: h.encolar });
    detachRef.current = () => {
      node.removeEventListener('touchstart', start);
      node.removeEventListener('touchmove', move);
      node.removeEventListener('touchend', end);
      node.removeEventListener('touchcancel', cancel);
      h.detach(node);
    };
  }, []);

  /* EL ATERRIZAJE (PAGER-2) — LA PESTAÑA DE ENFRENTE CAMBIÓ.
     Efecto DE LAYOUT y no pasivo, por la misma razón que el aterrizaje de
     Analíticas (R-6): corre después de que React colocó el carril en su nueva
     posición de reposo y ANTES del primer paint, así que las dos escrituras —la
     de React y la de aquí— caen en el mismo frame y no hay brinco. Con un
     `useEffect` normal el navegador pintaría un frame con el carril al doble de
     desplazamiento.
     En el primer render no hay nada que aterrizar: la comparación con el ref lo
     dice, y por eso montar el carril no toca ni un estilo. */
  const tabAnteriorRef = useRef(tab);
  useLayoutEffect(() => {
    if (tabAnteriorRef.current === tab) return;
    tabAnteriorRef.current = tab;
    handlersRef.current.aterrizar(nodeRef.current);
  }, [tab]);

  // Un solo click tragado, y sólo si de verdad hubo arrastre.
  const onClickCapture = useCallback((e) => {
    if (!swallowRef.current) return;
    swallowRef.current = false;
    e.preventDefault();
    e.stopPropagation();
  }, []);

  if (!IS_APP_BUILD) return NO_PROPS;
  return { ref, onClickCapture };
}
